/* eslint-disable react-hooks/exhaustive-deps */
import {getFullName, toastError} from "helpers"
import {CommunicationProvider} from "context/CommunicationContext"
import {ChatRoomProvider} from "context/ChatRoomContext"
import styles from "./ChatModalV2.module.css"
import {BasePopup} from "components"
import {StudentChat} from "../StudentChat"
import {OptInInfo} from "components/ui"
import {useModel, useUser} from "hooks"
import {useEffect, useState} from "react"
import {intersection} from "lodash"

type Props = {
    user: any
    onShow: boolean
    onClose: () => void
    userIdField: string
    departmentId: number
}

const ChatModal = (props: Props) => {
    const {departmentId, user, userIdField, onClose, onShow} = props
    const model = useModel()
    const [isCampusConditionMet, setIsCampusConditionMet] = useState(false)

    const {user: userData} = useUser({userId: user?.[userIdField]})

    useEffect(() => {
        checkCampusCondition()
    }, [user])

    const checkCampusCondition = async () => {
        const studentCampusIds: number[] = user?.campusIds || []
        const currentUser = await model.getOneCompleteUser(model.user.id)
        const userCampuses = currentUser.profiles.map(({campuses}) => campuses.map(({id}) => id))
        const userCampusIds = userCampuses.flatMap((id) => id)
        const sameCampusIds = intersection(userCampusIds, studentCampusIds)

        if (!model.isAdmin() && studentCampusIds.length === 0) {
            toastError("This student is not belong to any campus")
            onClose()
            return
        }

        if (!model.isAdmin() && sameCampusIds.length === 0) {
            toastError("You can only message students who belong to the same campus")
            onClose()
            return
        }

        setIsCampusConditionMet(true)
    }

    if (!isCampusConditionMet) {
        return null
    }

    return (
        <BasePopup
            isShow={onShow}
            onClose={onClose}
            leftIcon="MESSAGE"
            leftIconColor="#fff"
            width="700px"
            destroyOnClose>
            <div className={styles.title}>{`Message to ${getFullName(user)}`}</div>
            <div className={styles.infoWrap}>
                <span className={styles.spanId}>ID: {user?.customUserId}</span>
                {userData && <OptInInfo user={userData} />}
            </div>
            <StudentChat user={user} userIdField={userIdField} departmentId={departmentId} />
        </BasePopup>
    )
}

export function ChatModalV2(props: Props) {
    return (
        <CommunicationProvider>
            <ChatRoomProvider>
                <ChatModal {...props} />
            </ChatRoomProvider>
        </CommunicationProvider>
    )
}
